import type { RouteRecordRaw } from 'vue-router'
import { MenuCode } from '@/shared'
import { RouteList } from '@/routes/RouteList'
import { FeatureEnum } from '@/enums/FeatureEnum'
import { AbilityEnum } from '@/enums/AbilityEnum'
import { TaskListType } from '@/enums/TaskEnum'

const TaskTypesView = () => import('@/views/Tasks/TaskTypesView.vue')
const TaskTemplateView = () => import('@/views/Tasks/TaskTemplateView.vue')
const TasksListView = () => import('@/views/Tasks/TasksListView.vue')
const TasksCalendarView = () => import('@/views/Tasks/TasksCalendarView.vue')
const TaskView = () => import('@/views/Tasks/TaskView.vue')
const DashboardMain = () => import('@/components/Dashboard/DashboardMain.vue')
const SubSideBar = () => import('@/components/Layout/SubSideBar.vue')
const AuthNavBar = () => import('@/components/Layout/AuthenticatedNavBar.vue')

const taskRoutes: RouteRecordRaw[] = [
  {
    path: RouteList.TASKS.TASKS.INDEX.PATH,
    name: RouteList.TASKS.TASKS.INDEX.NAME,
    components: {
      default: DashboardMain,
      NavBar: AuthNavBar,
      SideBar: SubSideBar,
    },
    meta: {
      requiresAuth: true,
      requiresSubscription: true,
      title: 'Tasks',
    },
    props: {
      SideBar: {
        menuCode: MenuCode.Task,
        title: 'Tasks',
      },
    },
    redirect: (to) => ({
      name: RouteList.TASKS.TASKS.LIST.NAME,
      params: {
        businessSlug: to.params.businessSlug,
        type: TaskListType.Active,
      },
    }),
    children: [
      {
        path: RouteList.TASKS.TASKS.LIST.PATH,
        name: RouteList.TASKS.TASKS.LIST.NAME,
        component: TasksListView,
        meta: {
          feature: [FeatureEnum.SETTINGS_TASKS],
          permission: [AbilityEnum.TASKS_VIEW, AbilityEnum.TASKS],
        },
      },
      {
        path: RouteList.TASKS.TASKS.CALENDAR.PATH,
        name: RouteList.TASKS.TASKS.CALENDAR.NAME,
        component: TasksCalendarView,
        meta: {
          feature: [FeatureEnum.SETTINGS_TASKS],
          permission: [AbilityEnum.TASKS_VIEW, AbilityEnum.TASKS],
        },
      },
      {
        path: RouteList.TASKS.TASKS.TASK.PATH,
        name: RouteList.TASKS.TASKS.TASK.NAME,
        component: TaskView,
        meta: {
          feature: [FeatureEnum.SETTINGS_TASKS],
          permission: [AbilityEnum.TASKS_VIEW, AbilityEnum.TASKS],
        },
      },
      {
        path: RouteList.TASKS.TASK_TYPES.INDEX.PATH,
        name: RouteList.TASKS.TASK_TYPES.INDEX.NAME,
        component: TaskTypesView,
        meta: {
          feature: [FeatureEnum.SETTINGS_TASKS],
          permission: [AbilityEnum.SETTING_TASKS_TYPES, AbilityEnum.TASKS],
          title: 'Task Types',
        },
      },
      {
        path: RouteList.TASKS.TASKS_TEMPLATES.INDEX.PATH,
        name: RouteList.TASKS.TASKS_TEMPLATES.INDEX.NAME,
        redirect: {
          name: RouteList.TASKS.TASKS_TEMPLATES.BUSINESS.NAME,
        },
        meta: {
          feature: [FeatureEnum.SETTINGS_TASKS],
          permission: [AbilityEnum.SETTING_TASKS_TEMPLATES, AbilityEnum.TASKS],
          title: 'Task Templates',
        },
      },
      {
        path: RouteList.TASKS.TASKS_TEMPLATES.BUSINESS.PATH,
        name: RouteList.TASKS.TASKS_TEMPLATES.BUSINESS.NAME,
        component: TaskTemplateView,
        meta: {
          feature: [FeatureEnum.SETTINGS_TASKS],
          permission: [AbilityEnum.SETTING_TASKS_TEMPLATES, AbilityEnum.TASKS],
          title: 'Task Templates',
        },
      },
      {
        path: RouteList.TASKS.TASKS_TEMPLATES.LMS.PATH,
        name: RouteList.TASKS.TASKS_TEMPLATES.LMS.NAME,
        component: TaskTemplateView,
        meta: {
          feature: [FeatureEnum.SETTINGS_TASKS],
          permission: [
            AbilityEnum.LMS_LEADS,
            AbilityEnum.SETTING_TASKS_TEMPLATES,
            AbilityEnum.TASKS,
          ],
          title: 'Task Templates',
        },
      },
      {
        path: RouteList.TASKS.TASKS_TEMPLATES.EMS.PATH,
        name: RouteList.TASKS.TASKS_TEMPLATES.EMS.NAME,
        component: TaskTemplateView,
        meta: {
          feature: [FeatureEnum.SETTINGS_TASKS],
          permission: [
            AbilityEnum.EMS_LEADS,
            AbilityEnum.SETTING_TASKS_TEMPLATES,
            AbilityEnum.TASKS,
          ],
          title: 'Task Templates',
        },
      },
    ],
  },
]

export default <RouteRecordRaw[]>[...taskRoutes]
